export const orderStatus = [
  { id: 0, name: 'allOrder', title: '全部' },
  { id: 1, name: 'waitPay', title: '待付款' },
  { id: 2, name: 'waitSent', title: '待发货' },
  { id: 3, name: 'waitReceipt', title: '待收货' },
  { id: 4, name: 'Completed', title: '已完成' },
  { id: 9, name: 'Cancelled', title: '已取消' },
  { id: 5, name: 'afterSale', title: '售后' }
]

export function orderType (value) {
  const result = orderStatus.find(item => {
    return item.title === value
  })
  return result
}
